// extracted by mini-css-extract-plugin
module.exports = {"singlearrow":"singlearrowsvg-module--singlearrow--3C3ip"};